export const consolePrimaryColor = "#605CFF";
